import { OfferStateType } from '.generated/kysely/enums'

const offerStateConfig: Record<
  OfferStateType,
  { className: string; name: string }
> = {
  [OfferStateType.DRAFT]: {
    className: 'bg-gray-20 text-text-primary',
    name: 'Entwurf',
  },
  [OfferStateType.PROGRESS]: {
    className: 'bg-tag-blue-background text-tag-blue-text',
    name: 'In Bearbeitung',
  },
  [OfferStateType.SUBMITTED]: {
    className: 'bg-tag-teal-background text-tag-teal-text',
    name: 'Eingabe erfolgt',
  },
  [OfferStateType.APPROVED]: {
    className: 'bg-tag-green-background text-tag-green-text',
    name: 'Zusage',
  },
  [OfferStateType.REJECTED]: {
    className: 'bg-tag-red-background text-tag-red-text',
    name: 'Absage',
  },
  [OfferStateType.NOT_SUBMITTED]: {
    className: 'bg-tag-red-background text-tag-magenta-text',
    name: 'Eingabe nicht erfolgt',
  },
}

export default offerStateConfig
